import { Box, Divider, Flex, Input } from '@chakra-ui/react';
import { Text } from '~/common/components/defaultUIComponents';
import useTranslate from '~/common/utils/translate';
import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { GlobalOverview } from './GlobalOverview';
import { ProjectBreakdown } from './ProjectBreakdown';
import React, { useState } from 'react';

const isoDays = (offset: number) => {
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return d.toISOString().slice(0, 10);
};

export const ProjectRecordsTab: React.FC = () => {
  const t = useTranslate();
  const [start, setStart] = useState(isoDays(-30));
  const [end, setEnd] = useState(isoDays(0));

  const [{ data: projects }] = ProjectApi.hooks.useProjectsQuery();

  const projectList =
    projects?.map((p) => ({ id: Number(p.id), name: p.name })) ?? [];

  return (
    <Box p={4}>
      <Flex gap={4} mb={4} align="flex-end" wrap="wrap">
        <Box>
          <Text fontSize="sm">{t('projectRecords.start')}</Text>
          <Input
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </Box>
        <Box>
          <Text fontSize="sm">{t('projectRecords.end')}</Text>
          <Input
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </Box>
      </Flex>

      <GlobalOverview start={start} end={end} />

      <Divider my={6} />

      <ProjectBreakdown start={start} end={end} projects={projectList} />
    </Box>
  );
};
